module.exports = __webpack_public_path__ + "static/img/3.c921543.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R507/3.jpg
// module id = Mhfu
// module chunks = 1